import { render, staticRenderFns } from "./MyResourcesListView.vue?vue&type=template&id=59d4d0e6&"
import script from "./MyResourcesListView.vue?vue&type=script&lang=js&"
export * from "./MyResourcesListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports